import styled from 'styled-components'

import AccountPagePanel from 'account/components/AccountPagePanel'
import AddressSummaryDisplay from 'checkout/components/ShippingAddressPanel/AddressSummaryDisplay'
import { t } from 'localization'
import { AccountQA } from 'shared/dataAttributes'
import { fonts, media } from 'shared/lib'
import { Address } from 'shared/types/Address'

const TP = 'account.components.shippingAddressPanel'

type ShippingAddressPanelProps = {
  shippingAddress?: Address | null
}

export const ShippingAddressPanel = ({ shippingAddress }: ShippingAddressPanelProps) => {
  if (!shippingAddress) {
    return (
      <AccountPagePanel
        qaAttr={AccountQA.ShippingAddress}
        title={t(`${TP}.shippingAddress`, 'Shipping Address')}
      >
        <Body data-qa={AccountQA.ShippingAddressEmptySection}>
          {t(`${TP}.pleaseAdd`, 'Please add a default shipping address.')}
        </Body>
      </AccountPagePanel>
    )
  }

  return (
    <AccountPagePanel
      qaAttr={AccountQA.ShippingAddress}
      title={t(`${TP}.shippingAddress`, 'Shipping Address')}
    >
      <AddressSummaryDisplay {...shippingAddress} qaAttr={AccountQA.ShippingAddress} />
    </AccountPagePanel>
  )
}

const Body = styled.div`
  line-height: 18px;
  ${fonts.BODY_TEXT}
  ${media.large`
    display: flex;
    justify-content: space-between;
  `}
`
